<template>
  <div class="wapper" v-if="isShow">
    <div class="header">
      <span class="icontemp stemp-close" @click="close"></span>
      投票
    </div>
    <div class="content" style="padding: 0">
      <iframe
        :src="src"
        style="height: 100%;width: 100%;"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
// import {ck, $subscriber } from "fire-wind-water";
// import ws from "../../services/webinar";
import { buildVoteData, buildVoteMethod, mounted } from "../../common/vote";
export default {
  name: "Question",
  data() {
    return buildVoteData({
      type: "wap"
    });
  },
  created() {
    let self = this;
    mounted(self);
  },
  methods: buildVoteMethod({})
};
</script>

<style scoped></style>
